










































import { store } from "@/store/store";
import { DeviceFilters, StateEnum } from "@/types/types";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";

import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({
  name: "DisponibilityCard",
  components: { StandartCard, Paragraph },
  props: {
    filters: {
      type: Object as () => DeviceFilters
    }
  },
  data() {
    return {
      disponibilityPourcent: { true: 0, false: 0 }
    };
  },
  mounted(): void {
    this.calculatePourcent();
  },
  methods: {
    calculatePourcent(): void {
      const devices_l = store.getters.DEVICE_ALL_ID.length;
      let result = { t: 0, f: 0 };
      store.getters.DEVICE_ALL_ID.forEach((device_id) => {
        const device = store.getters.DEVICE_BY_ID[device_id];
        store.getters.STATE_BY_ID[device.state].name === StateEnum.RESERVE_DISP ? result.t++ : result.f++;
      });
      this.disponibilityPourcent.true = result.t !== 0 ? (result.t / devices_l) * 100 : 0;
      this.disponibilityPourcent.false = result.f !== 0 ? (result.f / devices_l) * 100 : 0;
    },
    onChange(disponibility: string): void {
      this.$emit("onFilterChange", {
        type: "disponibility",
        value: disponibility === this.filters.disponibility ? "" : disponibility
      });
    }
  },
  computed: mapState({
    view(): string | null {
      return this.$store.state.view;
    }
  }),
  watch: {
    view: {
      handler(): void {
        this.calculatePourcent();
      }
    }
  }
});
